import { API_URL } from "config";
import Http from "util/https";
import { downloadFromUrl } from "../utils/common";

type Props = {
  dl_mode?: 0 | 1;
  // from: string;
  // to: string;
};

/**
 * 受注CSVをダウンロードするURLを取得
 * @param params ダウンロード条件が入っているクエリパラメータ
 */
export default async function downloadOrderSupplierCsv(params: Props) {
  console.log(`downloadOrderSupplierCsv`);
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/contract/csv/download`;
  const res = await http.post(url, params);
  console.log(res);

  // const res: {data: {url: string}} = {data: {url: 'https://sample-videos.com/csv/Sample-Spreadsheet-10-rows.csv'}}

  // downloadFromUrl(res.data.url, '注文依頼データ');
  downloadFromUrl(res.data.url, '受注一覧データ');

  return res.data;
}